module.exports = __webpack_public_path__ + "img/galery-rku10-2.5c4d5423.png";